import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { InformacionFactura, validar } from "./componentes/informacionfactura";
import { TimbradoFactura } from "./componentes/informaciontimbrado";
import { AuxiliarNotaDeCredito } from "./componentes/auxiliarnotadecredito";
import { InformacionGuia } from "./componentes/informacionguias";
import { TabItem } from "kea-react/src/tabs/tab";

type Entity = models.FacturaDto;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardarBanderasCobranza: () => Promise<void>;
    onGuardar: () => Promise<void>;
    onGuardarSinSalir: () => Promise<void>;
    onRefresh: () => Promise<void>;
    nuevo: boolean;
    permisos: models.Rol;
}

/**
* Componente para una factura
*/
class FacturaFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    permisos = (props: Props) => props.permisos;

    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    soloLectura = createSelectorRx(this.value, this.permisos, (value, permisos) => value.EsTimbrada || value.EsCancelada || !permisos.Facturas.VerMenu || !permisos.Facturas.VerCrearFacturaArbitraria);

    get Tabs() {
        const Timbrado = this.getField(TimbradoFactura);
        const value = this.props.value;

        const tabs = [
            { title: "Factura", iconClass: fa("ticket"), body: <InformacionFactura {...this.props} soloLectura={this.soloLectura(this.props)} /> },
            value.EsNotaDeCredito && {
                title: "Nota de credito", iconClass: fa("tag"), body: <AuxiliarNotaDeCredito {...this.props} soloLectura={this.soloLectura(this.props)} />
            },
            value.EsTimbrada && {
                title: "Timbrado", iconClass: fa("bell"), body: <Timbrado field="Timbrado" />
            }
        ];


        return tabs.filter(x => x).map(x => x as TabItem);
    }

    render() {
        const { value, onGuardar } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Timbrado = getField(TimbradoFactura);

        return (
            <div>
                <kea.Tab items={this.Tabs} />
                {
                    !this.soloLectura(this.props) &&
                    <div className="row">
                        <div className="col-md-12">
                            <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                        </div>
                    </div>
                }
            </div>);
    }
}

export const FacturaForm = componentToRx(FacturaFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/edit/form.tsx